import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle } from "@fortawesome/free-solid-svg-icons";
import { Say } from "../../../languages";

type Props = {
  emailAddress: string;
  orderId: string;
  photo: string;
  visible: boolean;
};

const OrderConfirmationComplete = ({ emailAddress, orderId, photo, visible }: Props) => {
  if (!visible) return null;

  return (
    <>
      <div className="order-confirmation__complete">
        <span className="order-confirmation__complete-icon">
          <FontAwesomeIcon icon={faCheckCircle} />
        </span>

        <div className="order-confirmation__complete-text">
          <p className="zeta">
            <strong>
              <Say phrase="chosen.thank_you.final_confirmation" />
            </strong>
          </p>
        </div>
      </div>

      <div className="order-confirmation__final-photo">
        <strong className="order-confirmation__final-photo-title">
          <Say
            phrase="chosen.thank_you.order_number"
            mutator={(value) => value.replace("{{orderId}}", orderId)}
          />
        </strong>
        <p>
          <Say phrase="chosen.thank_you.confirmation_email" /> <strong>{emailAddress}</strong>
        </p>
        <img src={photo} />
        <p>
          <strong>
            <Say phrase="chosen.thank_you.uploaded_photo_caption" />
          </strong>
        </p>
      </div>
    </>
  );
};

export default OrderConfirmationComplete;
